export default "__VITE_ASSET__DIm5q4Em__"